export interface DentalRequiredCardViolation {
  stdCode: string;
  requiredCardType: string;
  actualCardType: string;
}

/** 處置標準碼與必須使用的掛號卡別；新增限制時只需擴充此對照表。 */
export const DENTAL_REQUIRED_CARD_RULES: ReadonlyMap<string, string> = new Map<string, string>([
  ['91021C', '02']
]);

/** 純檢核：不修改處置、掛號、案類或療程資料。 */
export function getDentalRequiredCardViolations(
  stdCodes: ReadonlyArray<string>,
  cardType: string
): DentalRequiredCardViolation[] {
  const actualCardType = (cardType || '').trim().toUpperCase();
  const checkedCodes = new Set<string>();
  const violations: DentalRequiredCardViolation[] = [];
  for (const value of stdCodes || []) {
    const stdCode = (value || '').trim().toUpperCase();
    if (!stdCode || checkedCodes.has(stdCode)) continue;
    checkedCodes.add(stdCode);
    const requiredCardType = DENTAL_REQUIRED_CARD_RULES.get(stdCode);
    if (requiredCardType && actualCardType !== requiredCardType) {
      violations.push({ stdCode, requiredCardType, actualCardType });
    }
  }
  return violations;
}

export function formatDentalRequiredCardViolations(violations: ReadonlyArray<DentalRequiredCardViolation>): string {
  return violations.map(item =>
    '本筆含有 ' + item.stdCode + '，掛號卡別必須為 ' + item.requiredCardType
    + '（目前：' + (item.actualCardType || '未填') + '）。請離開並退掛，重新取 '
    + item.requiredCardType + ' 卡別再執行儲存或完診。'
  ).join('\n\n');
}
